import styled from 'styled-components';

import { COLORS, ANIM, MOBILE } from '../../../../theme/tokens';
import { Text } from '../../../../components';

// Mirrors the Settings → Website Domain DNS list so unmanaged-domain records read
// identically wherever they're shown.
export const Subtitle = styled(Text)`
  display: block;
  font-size: 13px;
  font-weight: 300;
  line-height: 1.5;
  color: ${COLORS.textMuted};
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Record = styled.div`
  padding: 14px 16px;
  border: 1px solid ${COLORS.panelBorder};
  border-radius: 12px;
  background: ${COLORS.surfaceSoft};
`;

export const RecordTop = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const TypeBadge = styled.span<{ $color: string; $bg: string }>`
  width: 28px;
  height: 28px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  color: ${(p) => p.$color};
  background: ${(p) => p.$bg};
`;

export const RecordName = styled(Text)`
  font-size: 15px;
  font-weight: 600;
  color: ${COLORS.textStrong};
`;

export const Cols = styled.div`
  display: grid;
  grid-template-columns: 0.7fr 1.7fr 0.8fr;
  gap: 14px;
  margin-top: 12px;

  ${MOBILE} {
    grid-template-columns: 1fr;
    gap: 18px;
  }
`;

export const Col = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const ColLabel = styled(Text)`
  font-size: 11px;
  color: ${COLORS.textFaint};
`;

export const ColRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const ColValue = styled(Text)`
  flex: 0 1 auto;
  min-width: 0;
  font-size: 14px;
  color: ${COLORS.featureName};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${MOBILE} {
    flex: 1 1 auto;
  }
`;

export const CopyBtn = styled.button`
  flex: 0 0 auto;
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  border: none;
  border-radius: 7px;
  background: transparent;
  color: ${COLORS.textFaint};
  cursor: pointer;
  transition: background ${ANIM.INTERACT_MS}ms, color ${ANIM.INTERACT_MS}ms;

  &:hover {
    background: ${COLORS.hoverWash};
    color: ${COLORS.textMuted};
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.accent};
    outline-offset: 2px;
  }

  ${MOBILE} {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    background: ${COLORS.surfaceFaint};
    color: ${COLORS.textMuted};
  }
`;
